<template>
  <div v-if="giftLabels.length" class="cart-gift-label">
    <span v-for="label in giftLabels" :key="label.type" class="cart-gift-tag">
      {{ label.text }}
    </span>
  </div>
</template>

<script>
import { getCartDiscountTags } from '@/views/shopping-cart/modules/cartDiscountTags';

export default {
  name: 'CartGiftLabel',
  props: {
    // 0:非礼物 1: 入会礼 2:生日礼 3:季度礼包
    giftType: {
      type: [String, Number],
      default: '',
    },
    // 1：普通类型，2: 积分商品, 3：赠品 4: 兑换券
    productSaleType: {
      type: [String, Number],
      default: '',
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    valuationItem: {
      type: Object,
      default: () => ({}),
    },
    cartPrice: {
      type: Object,
      default: () => ({
        price: {},
      }),
    },
  },
  computed: {
    giftLabels() {
      return getCartDiscountTags({
        item: this.item,
        valuationItem: this.valuationItem,
        cartPrice: this.cartPrice,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.cart-gift-label {
  // Ps: 父级是flex布局。避免标签被压缩
  flex-shrink: 0;

  @include flex(normal, center);

  gap: 8px;
}
.cart-gift-tag {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
  padding: 3px 6px;
  height: 20px;
  line-height: 1;
  border-radius: 2px;
  white-space: nowrap;
  font-size: 12px;
  font-family: $f-hgr;
  color: #4c2a01;
  background: #fff3df;
  box-sizing: border-box;
}
</style>
